import React, { useMemo, useState } from 'react'
import ProjectPopUp from '../ProjectPopUp';
import FisProjectsIcon from "../../../images/FisProjectsIcon.png";
import HttpClient from '../../../utils/HttpClient';
import toast from 'react-hot-toast';
import { useLanguage } from '../../../Providers/LanguageContext';
import Select from 'react-select';
import { useUserData } from '../../../Providers/UserWrapper';
import moment from 'moment';
import './DeleteModal.css';
import timezones from 'timezones-list';

const ProjectSidebar = ({
    getProjecData,
    setModalc,
    preojectAllData,
    setTaskDetailData,
    selectAssignUserMemo,
    selectCustVendorMemo,
    selectCurrencyMemo,
    getTaskData,
    fetchEntireTask,
}) => {
    const { language, currentLanguage } = useLanguage();
    const { isMainUserMemo, profileData } = useUserData();
    const [isEdit, setIsEdit] = useState(false);
    const [projectId, setProjectId] = useState('');

    const initSelectData = { value: "", label: "" }
    const initData = {
        projectName: "",
        projectNotes: "",
        projectStatus: "",
        assignToUser: [],
        linkUserCustVendor: '',
        linkTask: "",
        startDate: "",
        endDate: "",
        clientName: "",
        clientEmail: "",
        budget: "",
        currency: '',
        language: "EN",
        budgetDetails: [],
    };

    const initBudgetDetail = {
        title: "",
        amount: "",
        myProfit: "",
        toBeUsed: "",
        notes: ""
    };

    const [formData, setFormData] = useState(initData);
    const [linkedTask, setLinkedTask] = useState([]);
    const [searchedData, setSearchedData] = useState(initSelectData);
    const [showBudgetModal, setShowBudgetModal] = useState(false);
    const [budgetDetails, setBudgetDetails] = useState([{ ...initBudgetDetail }]);

    // Add these state variables for delete confirmation
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteConfirmText, setDeleteConfirmText] = useState('');
    const [projectToDelete, setProjectToDelete] = useState(null);
    const [deleting, setDeleting] = useState(false);
    // Add timezone state
    const [selectedTimezone, setSelectedTimezone] = useState('');


    // Add timezone options formatting
    const timezoneOptions = useMemo(() => {
        return timezones.map(tz => ({
            value: tz.tzCode,
            label: `${tz.label} (${tz.name})`
        }));
    }, []);

    // Helper function to convert date to selected timezone
    const convertDateToTimezone = (dateString, timezone) => {
        if (!dateString || !timezone) return dateString;

        try {
            const date = new Date(dateString);
            // Convert to timezone-specific string
            return new Intl.DateTimeFormat('en-US', {
                timeZone: timezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).format(date);
        } catch (error) {
            console.error('Error converting date:', error);
            return dateString;
        }
    };


    // Delete confirmation handler
    const handleDeleteClick = (project) => {
        setProjectToDelete(project);
        setDeleteModalOpen(true);
        setDeleteConfirmText('');
    };

    // Confirm delete action
    const confirmDelete = async () => {
        if (deleteConfirmText.toLowerCase() !== 'delete') {
            toast.error('Please type "delete" to confirm');
            return;
        }

        setDeleting(true);
        try {
            await handleDeleteProject(projectToDelete._id);
            setDeleteModalOpen(false);
            setProjectToDelete(null);
            setDeleteConfirmText('');
        } catch (error) {
            toast.error('Failed to delete project');
        } finally {
            setDeleting(false);
        }
    };

    const searchSelectOptionMemo = useMemo(() => {
        return preojectAllData?.map((item) => ({
            value: item,
            label: item?.projectName,
        }))
    }, [preojectAllData]);

    // Helper function to format assignToUser for Select component
    const formatAssignToUser = (userArray) => {
        if (!userArray || !Array.isArray(userArray)) return [];

        return userArray.map(user => ({
            value: user._id || user.value,
            label: user.name || `User ${user._id}`
        }));
    };

    // Helper function to format currency for Select component
    const formatCurrency = (currencyValue) => {
        if (!currencyValue) return initSelectData;

        const currency = selectCurrencyMemo?.find(item => item.value === currencyValue);
        return currency || initSelectData;
    };

    // Helper function to format date for input[type="date"]
    // const formatDateForInput = (dateString) => {
    //     if (!dateString) return "";
    //     return moment(dateString).format('YYYY-MM-DD');
    // };

    // Modified formatDateForInput function
    const formatDateForInput = (dateString, timezone = selectedTimezone) => {
        if (!dateString) return "";

        if (timezone) {
            return convertDateToTimezone(dateString, timezone);
        }

        return moment(dateString).format('YYYY-MM-DD');
    };

    //on change 
    const handleProjectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    }

    // validate
    const validate = () => {
        if (!formData.projectName) {
            toast.error("Project Name is Required")
            return true
        }
        if (!formData.projectNotes) {
            toast.error("Project Notes is Required")
            return true
        }
        if (!formData.startDate) {
            toast.error("Start Date is Required")
            return true
        }
        if (!formData.endDate) {
            toast.error("End Date is Required")
            return true
        }
        return false
    }

    // submit create
    const handleCreateProject = async () => {
        if (validate()) {
            return
        };

        // Convert dates to selected timezone
        const startDateConverted = selectedTimezone
            ? convertDateToTimezone(formData.startDate, selectedTimezone)
            : formData.startDate;

        const endDateConverted = selectedTimezone
            ? convertDateToTimezone(formData.endDate, selectedTimezone)
            : formData.endDate;

        const data = {
            "projectName": formData.projectName,
            "projectNotes": formData.projectNotes,
            "projectStatus": formData.projectStatus ? formData.projectStatus : "open",
            "assignToUser": formData.assignToUser?.length > 0
                ? formData.assignToUser?.map(user => user.value)
                : [profileData?._id],
            "linkedUser": formData.linkUserCustVendor?.value,
            "linkedTask": formData.linkTask,
            // "startDate": formData.startDate,
            // "endDate": formData.endDate,
            "startDate": startDateConverted,
            "endDate": endDateConverted,
            "clientName": formData?.clientName,
            "clientEmail": formData?.clientEmail,
            "budget": formData?.budget ? +formData?.budget : 0,
            "currency": formData?.currency?.value || '',
            "language": formData?.language,
            "budgetDetails": [...budgetDetails],
            timeZone: selectedTimezone,
        }

        try {
            const res = await HttpClient.requestData("add-project-eventdetails_new", "POST", data);
            if (res && res?.status) {
                toast.success(res?.message || "Project Added Successfully");
                getProjecData();
                setFormData(initData);
                setBudgetDetails([{ ...initBudgetDetail }]);
                setSelectedTimezone("");
            } else {
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
        }
    };



    // update create
    const handleUpdateProject = async () => {
        if (validate()) {
            return
        }
        // Convert dates to selected timezone
        const startDateConverted = selectedTimezone
            ? convertDateToTimezone(formData.startDate, selectedTimezone)
            : formData.startDate;

        const endDateConverted = selectedTimezone
            ? convertDateToTimezone(formData.endDate, selectedTimezone)
            : formData.endDate;
        const data = {
            "projectName": formData.projectName,
            "projectNotes": formData.projectNotes,
            "projectStatus": formData.projectStatus ? formData.projectStatus : "open",
            "assignToUser": formData.assignToUser?.length > 0
                ? formData.assignToUser?.map(user => user.value)
                : [profileData?._id],
            "linkedUser": formData.linkUserCustVendor?.value,
            "linkedTask": formData.linkTask,
            // "startDate": formData.startDate,
            // "endDate": formData.endDate,
            "startDate": startDateConverted,
            "endDate": endDateConverted,
            "clientName": formData?.clientName,
            "clientEmail": formData?.clientEmail,
            "budget": formData?.budget ? +formData?.budget : 0,
            "currency": formData?.currency?.value || '',
            "language": formData?.language,
            "budgetDetails": budgetDetails?.map(item => ({
                "amount": item.amount || 0,
                "myProfit": item.myProfit || 0,
                "toBeUsed": item.toBeUsed || 0,
                "notes": item.notes || '',
                "title": item?.title || '',
            })),
            timeZone: selectedTimezone,
        }

        try {
            const res = await HttpClient.requestData(`update-project-eventDetails/${projectId}`, "PUT", data);
            if (res && res?.status) {
                toast.success(res?.message || "Project Updated Successfully");
                getProjecData();
                setFormData(initData);
                setBudgetDetails([{ ...initBudgetDetail }]);
                setSelectedTimezone("");
            } else {
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
        }
    };

    // delete project by :id ...
    const handleDeleteProject = async projectId => {
        try {
            const res = await HttpClient.requestData(`delete-project-eventDetails/${projectId}`, "DELETE");
            if (res && res?.status) {
                toast.success(res?.message || "Project Deleted Successfully");
                getProjecData();
                getTaskData();
                fetchEntireTask();
            } else {
                toast.error(res?.message || 'something went wrong!!!');
            }
        } catch (error) {
            toast.error(error?.message || 'something went wrong!!!');
        }
    };

    // Handle budget detail change
    // const handleBudgetDetailChange = (index, e) => {
    //     const { name, value } = e.target;
    //     const updatedDetails = [...budgetDetails];
    //     updatedDetails[index][name] = value;

    //     if (name === 'amount' || name === 'myProfit') {
    //         const amount = +(updatedDetails[index].amount) || 0;
    //         updatedDetails[index].amount = amount;
    //         const profit = +(updatedDetails[index].myProfit) || 0;
    //         updatedDetails[index].myProfit = profit;
    //         updatedDetails[index].toBeUsed = (amount - profit);
    //     }

    //     setBudgetDetails(updatedDetails);
    // };


    // Handle budget detail change
    const handleBudgetDetailChange = (index, e) => {
        const { name, value } = e.target;
        const updatedDetails = [...budgetDetails];
        updatedDetails[index][name] = value;

        if (name === 'amount' || name === 'myProfit') {
            const amount = +(updatedDetails[index].amount) || 0;
            const profit = +(updatedDetails[index].myProfit) || 0;

            // Validate that profit cannot exceed amount
            if (name === 'myProfit' && profit > amount) {
                toast.error("Profit cannot be more than the total amount");
                // Reset profit to current amount if it exceeds
                updatedDetails[index].myProfit = amount;
                updatedDetails[index].toBeUsed = 0;
            } else {
                updatedDetails[index].amount = amount;
                updatedDetails[index].myProfit = profit;
                updatedDetails[index].toBeUsed = (amount - profit);
            }
        }

        setBudgetDetails(updatedDetails);
    };

    // Add new budget detail form
    const addBudgetDetail = () => {
        setBudgetDetails([...budgetDetails, { ...initBudgetDetail }]);
    };

    // Remove budget detail form
    const removeBudgetDetail = (index) => {
        if (budgetDetails.length > 1) {
            const updatedDetails = [...budgetDetails];
            updatedDetails.splice(index, 1);
            setBudgetDetails(updatedDetails);
        }
    };

    // console.log("formData >>>>> ", formData);


    return (
        <div>
            <form action="" className="taskEvForm">
                <div>
                    <div className="taskMainInpDiv">
                        <div className="taskTabInps" style={{ width: "100%" }}>
                            <Select
                                className="taskUpperInpSearch"
                                placeholder={language.search}
                                isClearable={true}
                                isSearchable={true}
                                value={searchedData?.value === "" ? null : searchedData}
                                options={searchSelectOptionMemo}
                                onChange={e => {
                                    if (e) {
                                        // console.log("e.target.value>>>>>??????: ", e.value.timeZone);
                                        setSearchedData({ value: e.value, label: e.value?.projectName });
                                        setTaskDetailData(e.value);

                                        // Format assignToUser for the Select component
                                        const formattedAssignToUser = formatAssignToUser(e.value?.assignToUser);

                                        // console.log("formattedAssignToUser: ", formattedAssignToUser)

                                        // Format currency for the Select component
                                        const formattedCurrency = formatCurrency(e.value?.currency);

                                        // Format dates for date inputs
                                        const formattedStartDate = formatDateForInput(e.value?.startDate);
                                        const formattedEndDate = formatDateForInput(e.value?.endDate);
                                        // console.log("formattedStartDate: ", formattedStartDate);
                                        // console.log("formattedEndDate: ", formattedEndDate);
                                        setBudgetDetails([{ ...initBudgetDetail }]);
                                        setProjectId(e.value?._id || '');

                                        // ADD THIS LINE: Set the selected timezone
                                        setSelectedTimezone(e.value?.timeZone || '');


                                        setFormData({
                                            projectName: e?.value?.projectName || "",
                                            projectNotes: e?.value?.projectNotes || "",
                                            projectStatus: e?.value?.projectStatus || "",
                                            assignToUser: formattedAssignToUser,
                                            linkUserCustVendor: e?.value?.linkUserCustVendor || initSelectData,
                                            linkTask: e?.value?.linkTask || "",
                                            startDate: formattedStartDate,
                                            endDate: formattedEndDate,
                                            clientName: e?.value?.clientName || "",
                                            clientEmail: e?.value?.clientEmail || "",
                                            budget: e?.value?.budget || "",
                                            currency: formattedCurrency,
                                            language: e?.value?.language || "EN",
                                            budgetDetails: e?.value?.budgetDetails || [],
                                        });

                                        // Also update the budget details if they exist
                                        if (e.value?.budgetDetails && e.value.budgetDetails.length > 0) {
                                            setBudgetDetails(e.value.budgetDetails);
                                        }
                                        setIsEdit(true);
                                    } else {
                                        setSearchedData(initSelectData);
                                        setFormData(initData);
                                        setBudgetDetails([{ ...initBudgetDetail }]);

                                        // ADD THIS LINE: Reset timezone when clearing selection
                                        setSelectedTimezone('');
                                    }
                                }}
                            />
                            <i className="fa-solid fa-magnifying-glass taskSearGlass" style={{ left: "282px" }}></i>
                        </div>
                    </div>

                    {/* project name */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            placeholder={language.Project_Name}
                            className="taskUpperInp"
                            name='projectName'
                            value={formData.projectName}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* project notes */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            placeholder={language.Project_Notes}
                            className="taskUpperInp"
                            name='projectNotes'
                            value={formData.projectNotes}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* status */}
                    <div className="taskMainInpDiv">
                        <select
                            className="taskUpperInp"
                            name="projectStatus"
                            value={formData.projectStatus}
                            onChange={(e) => handleProjectChange(e)}
                        >
                            <option value="" disabled>
                                {language.Event_Status_optional}
                            </option>
                            <option value="open">{language.open}</option>
                            <option value="doing">{language.doing}</option>
                            <option value="done">{language.done}</option>
                            <option value="ideas">{language.ideas}</option>
                            <option value="onhold">{language.on_hold}</option>
                        </select>
                    </div>

                    {/* Assign to User (multi-select) */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder="Assign to User(Select)"
                            isClearable={true}
                            isSearchable={true}
                            isMulti={true}
                            name="assignedUser"
                            value={formData.assignToUser}
                            options={selectAssignUserMemo}
                            onChange={(selectedOptions) => {
                                setFormData(prev => ({ ...prev, assignToUser: selectedOptions || [] }));
                            }}
                        />
                    </div>

                    {/* Link Users, Customers. Vendors */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder={language.Link_Users_Customers_Vendors}
                            isClearable={true}
                            isSearchable={true}
                            name="linkUserCustVendor"
                            value={formData.linkUserCustVendor}
                            options={selectCustVendorMemo}
                            onChange={e => {
                                setFormData(prev => ({
                                    ...prev,
                                    linkUserCustVendor: e || initSelectData
                                }));
                            }}
                        />
                    </div>

                    {/* Link Tasks */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            className="taskUpperInp"
                            placeholder={language.Link_Tasks}
                            name='linkTask'
                            value={formData.linkTask}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* Timezone Dropdown */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder={language.Select_Timezone}
                            isClearable={true}
                            isSearchable={true}
                            value={timezoneOptions.find(option => option.value === selectedTimezone) || null}
                            options={timezoneOptions}
                            onChange={e => {
                                setSelectedTimezone(e?.value || '');
                            }}
                        />
                    </div>

                    <div className="taskMainInpDiv">
                        {/* Start Date */}
                        <div className="taskTabInps">
                            <input
                                type="date"
                                className="taskUpperInp"
                                placeholder={language.first}
                                name='startDate'
                                value={formData.startDate}
                                onChange={(e) => handleProjectChange(e)}
                            />
                        </div>

                        {/* End Date */}
                        <div className="taskTabInps">
                            <input
                                type="date"
                                className="taskUpperInp"
                                placeholder={language.last}
                                name='endDate'
                                value={formData.endDate}
                                onChange={(e) => handleProjectChange(e)}
                            />
                        </div>
                    </div>

                    {/* Client Name */}
                    <div className="taskMainInpDiv">
                        <input
                            type="text"
                            className="taskUpperInp"
                            placeholder={language.Client_Name}
                            name='clientName'
                            value={formData.clientName}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* Client Email */}
                    <div className="taskMainInpDiv">
                        <input
                            type="email"
                            className="taskUpperInp"
                            placeholder={language.Client_Email}
                            name='clientEmail'
                            value={formData.clientEmail}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* Budget */}
                    <div className="taskMainInpDiv">
                        <input
                            type="number"
                            className="taskUpperInp"
                            placeholder={language.Budget}
                            name='budget'
                            value={formData.budget}
                            min={0}
                            onKeyDown={(e) => {
                                if (e.key === '-') {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => handleProjectChange(e)}
                        />
                    </div>

                    {/* Currencies */}
                    <div className="taskMainInpDiv">
                        <Select
                            className="taskUpperInpSearch"
                            placeholder={language.Currency}
                            isClearable={true}
                            isSearchable={true}
                            name="currency"
                            value={formData.currency}
                            options={selectCurrencyMemo}
                            onChange={e => {
                                setFormData(prev => ({
                                    ...prev,
                                    currency: e || initSelectData
                                }));
                            }}
                        />
                    </div>

                    {/* Languages */}
                    <div className="taskMainInpDiv">
                        <select
                            className="taskUpperInp"
                            name="language"
                            value={formData.language}
                            onChange={(e) => handleProjectChange(e)}
                        >
                            <option value="">select language type</option>
                            <option value="EN">EN</option>
                            <option value="ES">ES</option>
                        </select>
                    </div>

                    {/* Budget Details */}
                    <div className="addNewTaskBtnDiv">
                        <button
                            type='button'
                            onClick={() => setShowBudgetModal(true)}
                        >+ {language.Budget_Details}</button>
                    </div>
                </div>

                <div className="postTaskBtnDiv">
                    {
                        !isEdit ? (
                            <button
                                onClick={() => handleCreateProject()}
                                type='button'
                            >
                                {language.CREATE}
                            </button>
                        ) : (
                            <button
                                onClick={() => handleUpdateProject()}
                                type='button'
                            >
                                {language.Update}
                            </button>
                        )
                    }
                </div>
            </form>

            {/* Rest of the component remains the same */}
            <div className="orDrFigDiv">
                <p className="orDrText">{language.Or_drop_to_calendar}</p>
                <figure className="fisiDrIconFig">
                    <img src={FisProjectsIcon} alt="..." />
                </figure>
            </div>

            {/* quick view */}
            {preojectAllData?.length !== 0 && (
                <div className="quickMainViewDiv">
                    <p className="ouickViewHead">{language.Quick_View}</p>
                    <div className="quickViewUlDiv">
                        <ul style={{ maxHeight: "300px" }} className="quickViewUl">
                            {preojectAllData?.map((item, i) => (
                                <li
                                    key={i}
                                    className="quickViewLi"
                                    onClick={() => {
                                        setModalc(true);
                                        setTaskDetailData(item);
                                    }}
                                >
                                    <div>
                                        <p className="quickAnsText">{item?.projectName}</p>
                                        <div className="quickDoneTextDiv">
                                            <p className="quickDoneText quickSkyDoneDot">
                                                {item?.projectStatus}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="quickViewActions">
                                        <figure className="quickFirstIconFig">
                                            <img src={FisProjectsIcon} alt="..." />
                                        </figure>
                                        <button
                                            className="deleteProjectBtn"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteClick(item);
                                            }}
                                            title="Delete Project"
                                        >
                                            <i className="fa-solid fa-trash"></i>
                                        </button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}

            {/* Budget Details Modal */}
            {showBudgetModal && (
                <div className="modal-overlay">
                    <div style={{ padding: "20px", background: '#fff' }} className="modal-content">
                        <div className="modal-header">
                            <h3>{language.Budget_Details}</h3>
                            <button
                                className="close-modal"
                                onClick={() => setShowBudgetModal(false)}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="modal-body">
                            {budgetDetails.map((detail, index) => (
                                <div key={index} className="budget-detail-form">
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>{language.title}</label>
                                            <input
                                                type="text"
                                                name="title"
                                                value={detail.title}
                                                onChange={(e) => handleBudgetDetailChange(index, e)}
                                                placeholder="e.g. Design, Development"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>{language.Amount}</label>
                                            <input
                                                type="number"
                                                name="amount"
                                                value={detail.amount}
                                                onChange={(e) => handleBudgetDetailChange(index, e)}
                                                placeholder="Total amount"
                                                min={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>{language.My_Profit || 'My Profit'}</label>
                                            <input
                                                type="number"
                                                name="myProfit"
                                                value={detail.myProfit}
                                                min={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => handleBudgetDetailChange(index, e)}
                                                placeholder="Your profit"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>{language.To_Be_Used || 'To Be Used'}</label>
                                            <input
                                                type="number"
                                                name="toBeUsed"
                                                value={detail.toBeUsed}
                                                min={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === '-') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => handleBudgetDetailChange(index, e)}
                                                placeholder="Amount to be used"
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>{language.Notes}</label>
                                        <input
                                            type="text"
                                            name="notes"
                                            value={detail.notes}
                                            onChange={(e) => handleBudgetDetailChange(index, e)}
                                            placeholder="Additional notes"
                                        />
                                    </div>
                                    <div className="form-actions">
                                        {budgetDetails.length > 1 && (
                                            <button
                                                type="button"
                                                className="remove-btn"
                                                onClick={() => removeBudgetDetail(index)}
                                            >
                                                <i className="fa-solid fa-minus"></i> {language.Remove}
                                            </button>
                                        )}
                                        {index === budgetDetails.length - 1 && (
                                            <button
                                                type="button"
                                                className="add-btn"
                                                style={{ background: '#0c2637', color: '#fff' }}
                                                onClick={addBudgetDetail}
                                            >
                                                <i className="fa-solid fa-plus"></i> {language.Add_More}
                                            </button>
                                        )}
                                    </div>
                                    {index < budgetDetails.length - 1 && <hr className="form-divider" />}
                                </div>
                            ))}
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: "center" }}>
                                <button
                                    style={{ background: '#ffdd00', color: '#0c2637', padding: "8px 50px", fontWeight: '500' }}
                                    type="button"
                                    className="save-btn"
                                    onClick={() => setShowBudgetModal(false)}
                                >
                                    {language.Save}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {/* Delete Confirmation Modal */}
            {deleteModalOpen && (
                <div className="delete-modal-overlay">
                    <div className="delete-modal-content">
                        <div className="delete-modal-header">
                            <h3>Delete Project</h3>
                            <button
                                className="delete-modal-close"
                                onClick={() => {
                                    setDeleteModalOpen(false);
                                    setProjectToDelete(null);
                                    setDeleteConfirmText('');
                                }}
                                disabled={deleting}
                            >
                                &times;
                            </button>
                        </div>
                        <div className="delete-modal-body">
                            {/* <p>
                                Are you sure you want to delete the project <strong>"{projectToDelete?.projectName}"</strong>?
                                 This will remove all tasks, milestones, deviations, and phases that are part of this project.
                            </p> */}
                            <p>
                                {language.Delete_Project_PopUp_Body1} <strong>"{projectToDelete?.projectName}"</strong>
                                {language.Delete_Project_PopUp_Body2}
                            </p>
                            <p>
                                Type <strong>delete</strong> to confirm:
                            </p>
                            <input
                                type="text"
                                className="delete-confirm-input"
                                value={deleteConfirmText}
                                onChange={(e) => setDeleteConfirmText(e.target.value)}
                                placeholder="Type 'delete' here"
                                disabled={deleting}
                            />
                        </div>
                        <div className="delete-modal-footer">
                            <button
                                className="delete-modal-cancel"
                                onClick={() => {
                                    setDeleteModalOpen(false);
                                    setProjectToDelete(null);
                                    setDeleteConfirmText('');
                                }}
                                disabled={deleting}
                            >
                                Cancel
                            </button>
                            <button
                                className="delete-modal-confirm"
                                onClick={confirmDelete}
                                disabled={deleteConfirmText.toLowerCase() !== 'delete' || deleting}
                            >
                                {deleting ? 'Deleting...' : 'Delete Project'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default ProjectSidebar